export const COOKIE_CONSENT_STORAGE_KEY = 'fesmelacta_cookie_consent_v1';
export const COOKIE_CONSENT_ACCEPTED = 'accepted';
export const COOKIE_CONSENT_REJECTED = 'rejected';

const GOOGLE_ANALYTICS_ID = 'G-KBYTSBTB18';
const CLARITY_PROJECT_ID = 'v8zirr4ziw';
const AHREFS_ANALYTICS_KEY = 'rzgRFNfWVy3Ac+WPFyyR8w';
const ANALYTICS_LOADED_FLAG = '__fesmelactaAnalyticsLoaded';

const supportedConsentValues = new Set([
  COOKIE_CONSENT_ACCEPTED,
  COOKIE_CONSENT_REJECTED,
]);

const getStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage || null;
};

const getDocument = () => {
  if (typeof document === 'undefined') {
    return null;
  }

  return document;
};

const getWindow = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window;
};

export function getCookieConsent(storage = getStorage()) {
  if (!storage) {
    return null;
  }

  try {
    const savedConsent = storage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    return supportedConsentValues.has(savedConsent) ? savedConsent : null;
  } catch (error) {
    return null;
  }
}

export function saveCookieConsent(consent, storage = getStorage()) {
  if (!supportedConsentValues.has(consent)) {
    return null;
  }

  try {
    storage?.setItem(COOKIE_CONSENT_STORAGE_KEY, consent);
  } catch (error) {
    // The current choice still applies for this page view if storage is unavailable.
  }

  return consent;
}

const appendScriptOnce = (doc, { id, src, attributes = {} }) => {
  if (!doc || doc.getElementById(id)) {
    return;
  }

  const script = doc.createElement('script');
  script.id = id;
  script.src = src;
  script.async = true;

  Object.entries(attributes).forEach(([name, value]) => {
    script.setAttribute(name, value);
  });

  doc.head.appendChild(script);
};

const loadGoogleAnalytics = (doc, win) => {
  win.dataLayer = win.dataLayer || [];

  if (typeof win.gtag !== 'function') {
    win.gtag = function gtag() {
      win.dataLayer.push(arguments);
    };
  }

  appendScriptOnce(doc, {
    id: 'fesmelacta-google-analytics',
    src: `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`,
  });

  win.gtag('js', new Date());
  win.gtag('config', GOOGLE_ANALYTICS_ID);
};

const loadClarity = (doc, win) => {
  if (typeof win.clarity !== 'function') {
    win.clarity = function clarity() {
      (win.clarity.q = win.clarity.q || []).push(arguments);
    };
  }

  appendScriptOnce(doc, {
    id: 'fesmelacta-clarity',
    src: `https://www.clarity.ms/tag/${CLARITY_PROJECT_ID}`,
  });
};

const loadAhrefsAnalytics = (doc) => {
  appendScriptOnce(doc, {
    id: 'fesmelacta-ahrefs',
    src: 'https://analytics.ahrefs.com/analytics.js',
    attributes: {
      'data-key': AHREFS_ANALYTICS_KEY,
    },
  });
};

export function loadAnalyticsScripts(doc = getDocument(), win = getWindow()) {
  if (!doc || !win || win[ANALYTICS_LOADED_FLAG]) {
    return;
  }

  loadGoogleAnalytics(doc, win);
  loadClarity(doc, win);
  loadAhrefsAnalytics(doc);

  win[ANALYTICS_LOADED_FLAG] = true;
}
